import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
import(/* webpackMode: "eager" */ "/app/public/assets/images/logo/logo_01.svg");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/About.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/BLockFeatureTwo.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/HeroBanner.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/ourPartners.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/PopularSports.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/home-six/PropertyOne.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/About.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/BLockFeatureTwo.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/FooterFive.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/HeroBanner.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/PopularEventsSlider.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home-six-legacy/UpcomingProperty.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/homes/home-four/PropertyOne.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SummerCampRedirect.tsx");
import(/* webpackMode: "eager" */ "/app/src/layouts/footers/FooterFive.tsx");
import(/* webpackMode: "eager" */ "/app/src/layouts/Wrapper.tsx")